import * as React from 'react';
import { Grid, Box } from '@moonpig/launchpad-components';
import { BlockItem } from '../BlockItem/BlockItem';
export var BlockLayoutE = function BlockLayoutE(_ref) {
  var items = _ref.items;
  return React.createElement(Grid, {
    gap: true
  }, React.createElement(Box, {
    width: {
      xs: 1,
      md: 1 / 2
    }
  }, React.createElement(BlockItem, items[0])), React.createElement(Box, {
    width: {
      xs: 1,
      md: 1 / 2
    }
  }, React.createElement(Grid, {
    gap: true
  }, items.slice(1).map(function (item, i) {
    return React.createElement(Box, {
      key: i,
      width: 1 / 2
    }, React.createElement(BlockItem, item));
  }))));
};